import { render, staticRenderFns } from "./FooterWideFacelift.vue?vue&type=template&id=0fc3c807&scoped=true&"
import script from "./FooterWideFacelift.vue?vue&type=script&lang=js&"
export * from "./FooterWideFacelift.vue?vue&type=script&lang=js&"
import style0 from "./FooterWideFacelift.vue?vue&type=style&index=0&id=0fc3c807&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc3c807",
  null
  
)

export default component.exports